export enum CalculationOperation {
  Fixed = 0,
  Sum = 1,
  Product = 2,
  Percentage = 100,
}
